import { mapActions } from "vuex";
export default {
  data: () => ({
    employeeId: "",
    newPassword: "",
    retypeNewPassword: "",
    hidePassword: true,
    hidePassword2: true,
  }),
  computed: {},
  methods: {
    ...mapActions("user", ["callForgotPass"]),
    toggleHidePassword() {
      this.hidePassword = !this.hidePassword;
    },
    toggleHidePassword2() {
      this.hidePassword2 = !this.hidePassword2;
    },
    notifyVue(type = "default", message) {
      this.$notify({
        message,
        timeout: 3000,
        icon: "ni ni-bell-55",
        type,
      });
    },
    updatePassword() {
      try {
        if (this.newPassword.length < 6) throw "Kata sandi baru minimal 6 karakter";
        if (this.newPassword !== this.retypeNewPassword) throw "Kata sandi tidak sama";
        this.notifyVue("success", "Kata sandi sudah berhasil diperbarui, silahkan login kembali");
        this.$router.push("/auth");
      } catch (err) {
        this.notifyVue("danger", err);
        // this.notifyVue("danger", err.response.data.error);
      }
    }
  },
  mounted() { },
};
